import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RegistrationStepService } from "../registration-step.service";
import { QuestionRequest } from "../models/question-request.model"; 
import { MatDialog } from "@angular/material/dialog";
import { LoaderComponent } from "src/app/loader/loader.component";
import { ActionSheetController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-qs-registration-type",
  templateUrl: "./qs-registration-type.component.html",
  styleUrls: ['../registration-step.component.scss']
})
export class QsRegistrationTypeComponent implements OnInit {
   @Input() questionCode: string = 'Q_REGISTRATION_TYPE';
  @Input() activeLang: string = "";
  questionRequest: QuestionRequest;
  progressSpinnerDialog: any = null;
  @Output() proceedNext = new EventEmitter();
  proceedEnabled: boolean = false;
  selectedRadioOption: string;
  dirtyForm: boolean = false;
  errorMessageVisible: boolean = false;
  errorMessage: string = '';
  registrationType : string;

  // registrationType!: 'CSMC' | 'PAP' | 'TISGAON';

  
  constructor(private registrationStepService: RegistrationStepService, private dialog: MatDialog,
    public actionSheetController: ActionSheetController, private translocoService: TranslocoService
  ) {}

  ngOnInit() {
    if(localStorage.getItem("editQuestionCode") && localStorage.getItem("editQuestionCode") === this.questionCode) {
      this.displayProgressSpinner();
      this.registrationStepService.fetchQuestionDetail(this.questionCode)
      .subscribe((data) => {  
        this.closeProgressSpinner();
        if(data.status === 'SUCCESS') {
          if(data.registrationTypeResponse) {
            this.selectedRadioOption = data.registrationTypeResponse.answer;
            this.evaluateProceed();
          }
          else {
            localStorage.removeItem("editQuestionCode");
            this.proceedNext.emit();      
          }
        }
        else {
          this.registrationStepService.showErrorMessage(data.errorMessage, true);
        }
      }, error => {
        this.closeProgressSpinner();
        this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
      });
    }
    else {
      // localStorage.removeItem("editQuestionCode");
      // this.proceedNext.emit();
    }
  }

  async proceed() {
    if(this.dirtyForm) {
      if(this.evaluateProceed()) {
        this.displayProgressSpinner();
        this.questionRequest = {
          registrationTypeRequestBody: {
            answer: this.selectedRadioOption,
          }
        };
        this.registrationStepService.saveQuestion(this.questionCode, this.questionRequest)
        .subscribe((data) => {
          this.closeProgressSpinner();
          if(data.status === 'SUCCESS') {
            localStorage.removeItem("editQuestionCode");
            this.proceedNext.emit();
          }
          else {
            this.registrationStepService.showErrorMessage(data.errorMessage, true);
          }
        }, error => {
          console.log(error);
          this.closeProgressSpinner();
          this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
        });
      }
      else {
        this.registrationStepService.frontendWarningToast("error-mandatory-fields", false);
      }
    }
  
    else {
      this.displayProgressSpinner();
      this.registrationStepService.proceedWithoutSave(this.questionCode)
      .subscribe((data) => {
        this.closeProgressSpinner();
        if(data.status === 'SUCCESS') {
          if(data.questionCode) {
            localStorage.setItem("editQuestionCode", data.questionCode);
            this.proceedNext.emit();
          }
          else {
            localStorage.removeItem("editQuestionCode");
            this.proceedNext.emit();
          }
        }
        else {
          this.registrationStepService.showErrorMessage(data.errorMessage, true);
        }
      }, error => {
        console.log(error);
        this.closeProgressSpinner();
        localStorage.removeItem("editQuestionCode");
        this.proceedNext.emit();
      });
    }
  }

  radioButtonClicked(event) {
    console.log(event);
    this.dirtyForm = true;
      // this.registrationType = this.selectedRadioOption as 'CSMC' | 'PAP' | 'TISGAON';

    if (this.selectedRadioOption  === "Tisgaon") {
        this.validateTisgaonResident();
      }

    else if(this.selectedRadioOption === 'Chhatrapati Sambhajinagar'){
      this.validateChhSambhajinagerResident();
    }
    this.evaluateProceed();
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
        disableClose: true,
        panelClass: "progressSpinner",
    });
  }

  async closeProgressSpinner() {
    if(this.progressSpinnerDialog) {
      this.progressSpinnerDialog.close();
    }
  }

  evaluateProceed() {
    this.proceedEnabled = false;
    if(this.selectedRadioOption) {
      this.proceedEnabled = true;
    }
    return this.proceedEnabled;
  }

  validateTisgaonResident(){
    this.registrationType = this.selectedRadioOption;
    // this.registrationType = this.selectedRadioOption.toUpperCase() as 'CSMC' | 'PAP' | 'TISGAON';

    this.registrationStepService.validateTisgaonResident(this.registrationType)
      .subscribe((response: any) => {

      if (response.status === 'SUCCESS' && response.exists) {

       
        this.errorMessageVisible = false;
        this.proceedEnabled = true;

      } else {
  // 🔥 ALERT ADDED BACK (this was missing)
        const msg = this.translocoService.translate('alerts.notATisgaonResident');
        alert(msg);
       

        this.errorMessageVisible = true;
        this.errorMessage = this.translocoService.translate('errors.notATisgaonResident');
        this.proceedEnabled = false;
      }

    }, error => {

      this.errorMessageVisible = true;
      this.errorMessage = this.translocoService.translate('errors.errorValidatingConstructionWorkersRegistrationNumber');
      this.proceedEnabled = false;

    });
    }
//     onSelectRegistrationType() {
//   this.registrationStepService.setRegistrationType(this.registrationType);
// }

 validateChhSambhajinagerResident(){
    this.registrationType = this.selectedRadioOption;
    
    this.registrationStepService.validateChhSambhajinagerResident(this.registrationType)
      .subscribe((response: any) => {

      if (response.status === 'SUCCESS' && response.exists) {
        this.errorMessageVisible = false;
        this.proceedEnabled = true;
      } else {
  // 🔥 ALERT ADDED BACK (this was missing)
        const msg = this.translocoService.translate('alerts.notAChhSambhajinagarResident');
        alert(msg);
       

        this.errorMessageVisible = true;
        this.errorMessage = this.translocoService.translate('errors.notAChhSambhajinagarResident');
        this.proceedEnabled = false;
      }

    }, error => {

      this.errorMessageVisible = true;
      this.errorMessage = this.translocoService.translate('errors.errorValidatingConstructionWorkersRegistrationNumber');
      this.proceedEnabled = false;

    });
 }

  }